import store from '@/stores/store'

const CustomTable = () => import(/* webpackChunkName: "custom-table" */ '@/components/CustomTable')
const CustomTableIndex = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/Index')

const CustomTableTable = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/Table')
const CustomTableTableIndex = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/table/Index')
const CustomTableTableShow = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/table/Show')

const CustomTableSchema = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/Schema')
const CustomTableSchemaIndex = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/schema/Index')
const CustomTableSchemaForm = () => import(/* webpackChunkName: "custom-table" */ '@/components/custom_table/schema/Form')

export default {
  children: [
    {
      component: CustomTableIndex,
      meta: {
        breadcrumbs: [{ name: 'CustomTable' }]
      },
      path: '/'
    },
    {
      children: [
        {
          component: CustomTableTableIndex,
          meta: {
            breadcrumbs: [
              { link: '/custom_table', name: 'CustomTable' },
              { name: 'Tabelas'}
            ]
          },
          path: '/'
        },
        {
          component: CustomTableTableShow,
          meta: {
            breadcrumbs: [
              { link: '/custom_table', name: 'CustomTable' },
              { link: '/custom_table/tables', name: 'Tabelas' },
              { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
            ]
          },
          path: ':id',
          props: true
        },
      ],
      component: CustomTableTable,
      path: 'tables'
    },
    {
      children: [
        {
          component: CustomTableSchemaIndex,
          meta: {
            breadcrumbs: [
              { link: '/custom_table', name: 'CustomTable' },
              { name: 'Layouts'}
            ]
          },
          path: '/'
        },
        {
          component: CustomTableSchemaForm,
          meta: {
            breadcrumbs: [
              { link: '/custom_table', name: 'CustomTable' },
              { link: '/custom_table/schemas', name: 'Layouts'},
              { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
            ]
          },
          path: ':id',
          props: true
        }
      ],
      component: CustomTableSchema,
      path: 'schemas'
    }
  ],
  component: CustomTable,
  path: 'custom_table'
}